import React from 'react';

import { FileUploadText, FileUploadTextPrimary } from '../styled';

function DragTextDefault() {
	return (
		<FileUploadText>
			<FileUploadTextPrimary>Drop file</FileUploadTextPrimary> to upload
		</FileUploadText>
	);
}

export default DragTextDefault;
